
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  id: '8ff4f5760c',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page static-content-page" data-name="terms">\n        <div class="navbar">\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back" aria-label="Back">\n                        <i class="icon icon-back"></i>\n                        <span class="if-not-md">Back</span>\n                    </a>\n                </div>\n                <div class="title">Terms of Use</div>\n            </div>\n        </div>\n        <div class="page-content">\n            <div class="static-hero">\n                <div class="static-hero-icon">\n                    <i class="icon f7-icons if-not-md">doc_text_fill</i>\n                    <i class="icon material-icons md-only">description</i>\n                </div>\n                <div class="static-hero-title">Terms &amp; Conditions</div>\n                <div class="static-hero-sub">End-user agreement for the mDOC platform.</div>\n            </div>\n            <div class="static-content-card">\n                <p>';
      r += c(ctx_1.data.mainTerms, ctx_1);
      r += '</p>\n                <p>';
      r += c(ctx_1.data.disclamer, ctx_1);
      r += '</p>\n                ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.data.details, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <h3 class="static-content-subheading">';
          r += c(ctx_2.title, ctx_2);
          r += '</h3>\n                <ol class="static-content-list">\n                    ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.chld, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <li>';
              r += c(ctx_3, ctx_3);
              r += '</li>\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                </ol>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n            </div>\n            <div class="static-content-spacer"></div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};
    